module.exports = __webpack_public_path__ + "img/image3.31792de8.png";